import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'

import './App.css'

const rootId = document.getElementById('root');

ReactDOM.render(<App />, rootId)
// WEBPACK FOOTER //
// ./src/index.js
